// extracted by mini-css-extract-plugin
export var featuredtrees = "FeaturedTrees-module--featuredtrees--8fb5e";
export var subhead = "FeaturedTrees-module--subhead--714b9";
export var treesContainer = "FeaturedTrees-module--treesContainer--bf449";
export var twoColumns = "FeaturedTrees-module--twoColumns--c5b13";